module.exports = __webpack_public_path__ + "07_bob_beige.2db7664e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/07_bob_beige.png
// module id = H8S8
// module chunks = 0